const defaultTheming = {
	'studio.styles.quiz.winners': {},
	'styles.interactions.polls.studio.results': {}, // the main container that wraps around the visualization
	'styles.interactions.polls.studio.results.question': {}, // question container
	'styles.interactions.polls.studio.results.question_title': {}, // question label
	'styles.interactions.polls.studio.results.question_index': {}, // the inline element indicating the index of the question (quiz)
	'styles.interactions.polls.studio.results.bar_wrapper': {}, // the wrapper around the bar
	'styles.interactions.polls.studio.results.bar': {}, // the bar
	'styles.interactions.polls.studio.results.grid': {}, // the wrapper around the bar (place to style the grid)
	'styles.interactions.polls.studio.results.correct_bar': {}, // the correct bar
	'styles.interactions.polls.studio.results.choice': {}, // the wrapper
	'styles.interactions.polls.studio.results.choice.image': {}, // the image if any in the bar
	'styles.interactions.polls.studio.results.choice.label': {}, // the percentage indicator above the bar
	'styles.interactions.polls.studio.results.choice.label.caret': {}, // the carret underneath the percentage indicator
	'styles.interactions.polls.studio.results.choice_label': {}, // the answer text underneath the bar
};

export default defaultTheming;



// WEBPACK FOOTER //
// ./src/ui/theming/index.js